import React from 'react'
import { FormattedHTMLMessage } from '@dragonraider5/react-intl'
import { SectionWrapper } from '../../components/Section'
import messages from './messages'

function RegisterWelcome() {
  return (
    <SectionWrapper>
      <FormattedHTMLMessage {...messages.welcomeTextHTML} tagName='div' />
    </SectionWrapper>
  )
}

export default RegisterWelcome
